module.exports = __webpack_public_path__ + "static/img/PROTE PU products discription2_deskstop.d7838873.jpg";